export const INITIATORS = {
  WIDGET: 'widget',
};

export function getInitiatorFromQuery(query) {
  return query && query.initiator;
}

export function makeInitiatorQueryString(initiator) {
  return `initiator=${initiator}`;
}



// WEBPACK FOOTER //
// ./src/shared/utils/initiators.js